import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Pricing from '../components/Pricing';
import SalesProcess from '../components/SalesProcess';

const HomePage: React.FC = () => {
  return (
    <div id="home-page">
      <Hero />
      <Features />
      {/* Sales Process section */}
      <SalesProcess />
      <Pricing />
    </div>
  );
};

export default HomePage; 